import React from 'react';
import Text from 'components/ui/text';

export default function SubstitutionsItemSummary({ item, removed }) {
  const price = ((item.discount_price || item.price || 0) * (item.quantity || 0)
  ).toFixed(2);

  return (
    <div className={`${removed ? 'substitutions-item--removed' : ''} clearfix`}>
      <div className="inline-block substitutions-item__descr">
        {!removed &&
          item.soldout &&
          item.stock_level !== item.quantity && (
            <Text weight="bold" className="text-danger">
              {item.stock_level
                ? `${item.stock_level}/${item.quantity} In Stock`
                : 'Out of Stock'}
            </Text>
          )}
        <Text weight="bold" secondary={removed}>
          {item.title} x {item.quantity}
        </Text>
        <Text secondary={removed} className="text-overflow">
          {item.subtitle}
        </Text>
        <Text secondary={removed}>{item.volume}</Text>
      </div>
      <img src={item.image} className="cart-item__thumbnail left" />
      <div className="right text-right">
        <Text weight="bold" secondary={removed}>
          {`${removed ? '-' : ''}$${price}`}
        </Text>
        {removed && (
          <Text weight="bold" secondary>
            Removed
          </Text>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./shared/components/substitutions/summary.js